import { type ConsoleApi } from './client';
import { HttpConsoleApi } from './http';
import { MockConsoleApi } from './mock/api';

export { ApiError, errorMessage, isApiError } from './client';
export type { ConsoleApi } from './client';
export { HttpConsoleApi } from './http';
export { MockConsoleApi } from './mock/api';

export type ApiMode = 'http' | 'mock';

/**
 * Pick the API for this build: the HTTP client when VITE_API_BASE_URL is set, otherwise the
 * in-memory mock. The header shows which one is live so nobody mistakes mock data for the page.
 */
export function createApi(): { api: ConsoleApi; mode: ApiMode; baseUrl: string | null } {
  const baseUrl = (import.meta.env.VITE_API_BASE_URL as string | undefined)?.trim();
  if (baseUrl) return { api: new HttpConsoleApi(baseUrl), mode: 'http', baseUrl };
  return { api: new MockConsoleApi(), mode: 'mock', baseUrl: null };
}
